module.exports = __webpack_public_path__ + "media/images/athletes/4296-695afd7f77b65fc14ca7e59a0ffd45fe.png";